import script from "./UserNameConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserNameConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserNameConfirmModal.vue?vue&type=style&index=0&id=0d7657f9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7657f9"]])

export default __exports__